export const platformAccess = {
  junior: {
    required: [
      { platform: 'Figma', access: 'Editor', purpose: 'UI design creation and collaboration', setup: 'Request editor access to UI design team workspace' },
      { platform: 'Slack', access: 'Member', purpose: 'UI design team communication', setup: 'Join #ui-design, #design-team, #frontend-team channels' },
      { platform: 'Adobe Creative Cloud', access: 'Individual', purpose: 'UI design and asset creation', setup: 'Request individual Creative Cloud license' },
      { platform: 'Zeplin', access: 'Editor', purpose: 'Design handoff and developer collaboration', setup: 'Request editor permissions for design handoff projects' }
    ],
    optional: [
      { platform: 'Sketch', access: 'Individual', purpose: 'UI design (macOS only)', setup: 'Request individual Sketch license for macOS users' },
      { platform: 'InVision', access: 'Viewer', purpose: 'Prototype sharing and feedback', setup: 'Request viewer access to design prototypes' }
    ]
  },
  mid: {
    required: [
      { platform: 'Abstract', access: 'Editor', purpose: 'Design version control and team collaboration', setup: 'Request editor access to design version control workspace' },
      { platform: 'Principle', access: 'Individual', purpose: 'UI animation and interaction design', setup: 'Request individual Principle license (macOS)' },
      { platform: 'IconJar', access: 'Individual', purpose: 'Icon library management', setup: 'Request individual IconJar license for icon organization' },
      { platform: 'After Effects', access: 'Individual', purpose: 'Motion graphics and UI animation', setup: 'Request After Effects license (part of Creative Cloud)' }
    ],
    optional: [
      { platform: 'Framer', access: 'Individual', purpose: 'Advanced prototyping and interaction', setup: 'Request individual Framer license' },
      { platform: 'ProtoPie', access: 'Individual', purpose: 'Interactive prototyping', setup: 'Request individual ProtoPie license' }
    ]
  },
  senior: {
    required: [
      { platform: 'Design Operations Platform', access: 'Admin', purpose: 'Enterprise UI design management and optimization', setup: 'Request admin access to design operations tools' },
      { platform: 'Advanced Design System Tools', access: 'Admin', purpose: 'Enterprise design system governance and automation', setup: 'Request admin permissions for design system management' },
      { platform: 'UI Analytics Suite', access: 'Admin', purpose: 'UI performance measurement and optimization', setup: 'Request admin access to UI analytics and performance tools' },
      { platform: 'Advanced Animation Suite', access: 'Admin', purpose: 'Professional motion design and animation', setup: 'Request admin access to enterprise animation tools' }
    ],
    optional: [
      { platform: 'AI Design Tools', access: 'Admin', purpose: 'AI-assisted UI design and automation', setup: 'Request admin access to AI design platforms' },
      { platform: 'Design Infrastructure', access: 'Admin', purpose: 'Scalable design system infrastructure', setup: 'Request admin permissions for design infrastructure management' }
    ]
  }
};
